<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        :color='stockLevel.color'
        v-bind="attrs"
        v-on="on"
      >
        {{ stockLevel.icon }}
      </v-icon>
    </template>
    <span>{{ stockLevel.text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: ['stock', 'quantity'],
  computed: {
    stockLevel () {
      let color = ''
      let icon = ''
      let text = ''
      if (this.stock === 0) {
        color = 'error'
        icon = 'mdi-gauge-empty'
        text = 'No stock'
      } else if (this.stock < this.quantity) {
        color = 'error'
        icon = 'mdi-gauge-low'
        text = 'No enought stock'
      } else if (this.stock < (this.quantity * 2)) {
        color = 'warning'
        icon = 'mdi-gauge'
        text = 'Less than 2 times the need'
      } else {
        color = 'success'
        icon = 'mdi-gauge-full'
        text = 'Enought stock'
      }
      return { color, icon, text }
    }
  }
}
</script>
